import { FormEvent, ReactElement, useState } from 'react'
import Checkbox from '../../../../components/Checkbox'
import InputSelect from '../../../../components/InputSelect'
import InputText from '../../../../components/InputText'
import { MaskPhone } from '../../../../utils/masks'
import { ReactComponent as Heart } from './assets/heart.svg'
import * as S from './styled'

export default function Contact (): ReactElement {
  const [messageSent, setMessageSent] = useState(false)
  const [form, setForm] = useState({
    email: '',
    message: '',
    name: '',
    notifications: false,
    phone: '',
    subject: '',
    terms: false
  })

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()

    console.log(form)
    setMessageSent(true)
  }

  return <S.Container id="fale-conosco">
    {messageSent
      ? <S.MessageSentContent>
        <Heart />

        <p><strong>Deu tudo certo ao enviar a sua solicitação.  Em breve, entraremos em contato com você!</strong></p>

        <span onClick={() => setMessageSent(false)}>Enviar nova solicitação</span>
      </S.MessageSentContent>
      : <>
      <S.Heading>
        <h1>Fale conosco</h1>

        <span><small>Campos obrigatórios *</small></span>
      </S.Heading>

      <S.Form onSubmit={handleSubmit}>
        <InputText
          label="Nome completo*"
          name="name"
          onChange={setForm}
          placeholder="ex: Maria Lucia Almeida"
          value={form.name}
        />

        <InputText
          label="E-mail*"
          name="email"
          onChange={setForm}
          placeholder="ex: ana@gmail.com"
          type="email"
          value={form.email}
        />

        <InputText
          label="Telefone*"
          mask={MaskPhone}
          name="phone"
          onChange={setForm}
          placeholder="ex. (11) 99999-9999"
          value={form.phone}
        />

        <InputSelect
          label="Selecione assunto*"
          name="subject"
        />

        <InputText
          as="textarea"
          label="Mensagem"
          name="message"
          onChange={setForm}
          placeholder="ex. Gostaria de mais informações sobre os benefícios..."
          value={form.message}
        />

        <Checkbox
          label={<>Li e aceito os <S.TermsLink to="">termos e condições</S.TermsLink>, sou maior de 18 anos*</>}
          name="terms"
          onChange={setForm}
        />

        <Checkbox
          label="Eu aceito notificações e contato via SMS, e-mail ou telefone"
          name="notifications"
          onChange={setForm}
        />

        <button type="submit">Enviar</button>
      </S.Form>
    </>}
  </S.Container>
}
